export const messages = {
  en: {
    // Navigation
    DASHBOARD: "Dashboard",
    LEADS: "Leads",
    PAC_NAV: "PAC",
    APPOINTMENTS_NAV: "Appointments",
    ADMINISTRATION: "Administration",
    // Appointments page
    APPOINTMENTS: {
      NO_DATA: "No appointments found",
      HEADERS: {
        LEAD: "Lead",
        PHONE: "Phone",
        DATE: "Date",
        TIME: "Time",
        COMMENT: "Comment",
        PAC: "Associated targets",
        IS_DONE: "Done",
      },
    },
    // PAC page
    PAC: {
      NO_DATA: "No targets found",
      LOAD_ERROR: "Failed to load targets, please try again.",
      STATUS: {
        IN_PROGRESS: "In progress",
        COMPLETED: "Completed",
      },
      FILTERS: {
        ALL: "All",
      },
      HEADERS: {
        TARGET_NAME: "Target",
        DESCRIPTION: "Description",
        STATUS: "Status",
        REVENUE_TARGET: "Revenue target",
        OFFERS_AMOUNT: "Offers amount",
        REVENUE_ACHIEVED_PERCENTAGE: "% Revenue achieved",
        OFFERS_COUNT: "Nb offers",
        LEADS: "Leads",
        APPOINTMENTS: "Appointments",
        ORDERS: "Orders",
        TARGET_DATE: "Target date",
      },
    },
    declareIncident: "Help center VIGIECO",
    // Lead status
    statusNew: "New",
    statusInProgress: "In progress",
    statusWon: "Won",
    statusLost: "Lost",
    // Lead priority
    priorityNone: "None",
    priorityLow: "Low",
    priorityMedium: "Medium",
    priorityHigh: "High",
    // Lead relevance / boolean
    yes: "Yes",
    no: "No",
    toBeAssessed: "To be assessed",
    // Campaign origin
    campaignTop20Clients: "Top 20 clients",
    campaignExpiringContracts: "Expiring contracts",
    campaignTenders: "Tenders",
    campaignExternal: "External",
    campaignOther: "Other",
    campaignBuildingGateway: "Building gateway",
    // Lead source
    sourcePasserelle: "Passthrough",
    sourceExcel: "Excel",
    sourceManual: "Manual",
    // PAC association
    withPac: "With PAC",
    withoutPac: "Without PAC",
    // Contact type
    client: "Client",
    prospect: "Prospect",
    // Generic
    errorGeneric: "An error occurred, please try again.",
    // Notifications
    notifications: {
      leadCreated: "Lead successfully created",
      leadUpdated: "Lead updated",
      appointmentCreated: "Appointment created",
      appointmentUpdated: "Appointment updated",
      appointmentDeleted: "Appointment deleted",
      pacCreated: "PAC created",
      pacUpdated: "PAC updated",
      pacDeleted: "PAC deleted",
      importPollingError: "Import tracking error. Please check the results.",
    },
  },
  fr: {
    // Navigation
    DASHBOARD: "Tableau de bord",
    LEADS: "Leads",
    PAC_NAV: "PAC",
    APPOINTMENTS_NAV: "Rendez-vous",
    ADMINISTRATION: "Administration",
    // Appointments page
    APPOINTMENTS: {
      NO_DATA: "Aucun rendez-vous trouvé",
      HEADERS: {
        LEAD: "Lead",
        PHONE: "Téléphone",
        DATE: "Date",
        TIME: "Heure",
        COMMENT: "Commentaire",
        PAC: "Cible associée",
        IS_DONE: "Réalisé",
      },
    },
    // PAC page
    PAC: {
      NO_DATA: "Aucune cible trouvée",
      LOAD_ERROR: "Échec du chargement des cibles, veuillez réessayer.",
      STATUS: {
        IN_PROGRESS: "En cours",
        COMPLETED: "Terminé",
      },
      FILTERS: {
        ALL: "Tous",
      },
      HEADERS: {
        TARGET_NAME: "Cible",
        DESCRIPTION: "Description",
        STATUS: "Statut",
        REVENUE_TARGET: "Objectif CA",
        OFFERS_AMOUNT: "Montant offres",
        REVENUE_ACHIEVED_PERCENTAGE: "% CA réalisé",
        OFFERS_COUNT: "Nb offres",
        LEADS: "Leads",
        APPOINTMENTS: "RDV",
        ORDERS: "Commandes",
        TARGET_DATE: "Date objectif",
      },
    },
    declareIncident: "Centre d’aide VIGIECO",
    // Lead status
    statusNew: "Nouveau",
    statusInProgress: "En cours",
    statusWon: "Gagné",
    statusLost: "Perdu",
    // Lead priority
    priorityNone: "Aucune",
    priorityLow: "Basse",
    priorityMedium: "Moyenne",
    priorityHigh: "Haute",
    // Lead relevance / boolean
    yes: "Oui",
    no: "Non",
    toBeAssessed: "À déterminer",
    // Campaign origin
    campaignTop20Clients: "Top 20 clients",
    campaignExpiringContracts: "Contrats expirants",
    campaignTenders: "Appels d'offres",
    campaignExternal: "Externe",
    campaignOther: "Autre",
    campaignBuildingGateway: "Passerelle Construction",
    // Lead source
    sourcePasserelle: "Passerelle",
    sourceExcel: "Excel",
    sourceManual: "Manuel",
    // PAC association
    withPac: "Avec PAC",
    withoutPac: "Sans PAC",
    // Contact type
    client: "Client",
    prospect: "Prospect",
    // Generic
    errorGeneric: "Une erreur est survenue, veuillez réessayer.",
    // Notifications
    notifications: {
      leadCreated: "Lead créé avec succès",
      leadUpdated: "Lead mis à jour",
      appointmentCreated: "Rendez-vous créé",
      appointmentUpdated: "Rendez-vous mis à jour",
      appointmentDeleted: "Rendez-vous supprimé",
      pacCreated: "PAC créé",
      pacUpdated: "PAC mis à jour",
      pacDeleted: "PAC supprimé",
      importPollingError:
        "Erreur lors du suivi de l'import. Veuillez vérifier les résultats.",
    },
  },
};
